export const FAST_PASSWORD_EXPIRATTION_DURATION_HOURS = 24;
